export const EXPERTISES_DATA = [
    {
        slug: "diagnostic-strategie-export",
        num: "01",
        title: "Diagnostic & stratégie export",
        tagline: "Évaluer, décider, planifier.",
        image: "/assets/terrain-mission-bureau.jpg",
        imageAspect: "aspect-[3/4]",
        imageAlt: "Mission WEYB — réunion de travail avec une entreprise accompagnée",
        intro: "Avant tout développement international, une entreprise doit savoir précisément d'où elle part et où elle peut aller. Le diagnostic export mesure votre maturité, la stratégie définit votre cap.",
        points: [
            { title: "Diagnostic export", desc: "Analyse de votre offre, de vos capacités, de vos ressources et de votre expérience internationale." },
            { title: "Maturité internationale", desc: "Évaluation de votre organisation, de vos outils et de vos équipes face aux exigences de l'export." },
            { title: "Stratégie export", desc: "Définition des objectifs, du positionnement et des ambitions par marché." },
            { title: "Priorisation des marchés", desc: "Classement des zones à plus fort potentiel : Europe, Afrique, MENA et au-delà." },
            { title: "Feuille de route", desc: "Un plan d'actions séquencé, réaliste et pilotable." },
        ],
        outcomes: ["Une vision claire de votre potentiel export", "Des marchés prioritaires justifiés", "Une feuille de route actionnable"],
        solution: { slug: "developpement-international", label: "Développement international" },
    },
    {
        slug: "etudes-de-marche",
        num: "02",
        title: "Études de marché",
        tagline: "Comprendre avant d'investir.",
        seoTitle: "Étude de marché export & international | WEYB",
        seoDescription:
            "Études de marché export et international : WEYB analyse demande, concurrence, réglementation, distribution et potentiel marché pour sécuriser vos décisions.",
        h1Title: "Études de marché export",
        heroTagline: "comprendre avant d'investir",
        heroIntro:
            "Une décision export ne se prend pas à l'intuition. WEYB réalise des études de marché internationales pour aider les PME et équipes export à évaluer le potentiel d'un marché : demande, concurrence, réglementation, circuits de distribution et conditions d'accès.",
        related: [
            { href: "/expertises/prospection-b2b-closing", label: "Étape suivante : la prospection B2B internationale" },
        ],
        image: "/assets/terrain-conference.jpg",
        imageAspect: "aspect-[4/3]",
        imageAlt: "Conférence WEYB — travail sur la stratégie commerciale",
        intro: "Une décision internationale ne se prend pas à l'intuition. Les études de marché de WEYB vous donnent une lecture factuelle des zones ciblées : demande, concurrence, réglementation, circuits de distribution.",
        points: [
            { title: "Études de marché international", desc: "Analyse complète d'un marché cible : taille, acteurs, prix, usages et barrières à l'entrée." },
            { title: "Analyse concurrentielle", desc: "Cartographie des concurrents locaux et internationaux, positionnements et prix pratiqués." },
            { title: "Veille marché", desc: "Suivi des évolutions réglementaires, commerciales et sectorielles de vos zones cibles." },
            { title: "Études assistées par IA", desc: "Via Export360, des études accélérées par l'intelligence artificielle, relues par des experts." },
        ],
        outcomes: ["Des décisions fondées sur des faits", "Une connaissance fine de vos concurrents", "Des risques identifiés avant l'investissement"],
        solution: { slug: "developpement-international", label: "Développement international" },
    },
    {
        slug: "prospection-b2b-closing",
        num: "03",
        title: "Prospection B2B & Closing",
        tagline: "Transformer les contacts en contrats.",
        seoTitle: "Prospection B2B internationale & closing export | WEYB",
        seoDescription:
            "WEYB accompagne votre prospection B2B internationale : ciblage, identification de prospects, prise de contact, rendez-vous et closing commercial export.",
        h1Title: "Prospection B2B internationale",
        heroTagline: "du ciblage au closing",
        heroIntro:
            "WEYB accompagne les PME et équipes commerciales dans leur prospection B2B internationale, de l'identification des marchés et prospects prioritaires jusqu'à la prise de rendez-vous, la négociation et le closing export.",
        related: [
            { href: "/expertises/etudes-de-marche", label: "En amont : les études de marché export" },
            { href: "/expertises/missions-b2b", label: "Aller sur le terrain : les missions commerciales B2B" },
        ],
        image: "/assets/terrain-partenaire-digital.jpg",
        imageAspect: "aspect-[16/10]",
        imageAlt: "Visite d'un partenaire technologique — mission de prospection WEYB",
        intro: "La prospection internationale exige méthode, outillage et persévérance. WEYB identifie, qualifie et approche vos futurs partenaires — et vous accompagne jusqu'à la signature.",
        points: [
            { title: "Identification de partenaires", desc: "Distributeurs, importateurs, agents ou clients finaux : une cible définie avec précision." },
            { title: "Prospection B2B ciblée", desc: "Campagnes structurées, documentées et suivies — pas de listes achetées ni d'envois de masse." },
            { title: "Qualification", desc: "Chaque contact est évalué : intérêt réel, capacité, fiabilité, adéquation avec votre offre." },
            { title: "Closing commercial", desc: "Appui à la négociation et à la conclusion des accords, dans la durée et la confiance." },
        ],
        outcomes: ["Un pipeline de prospects qualifiés", "Des rendez-vous avec de vrais décideurs", "Un accompagnement jusqu'à la signature"],
        solution: { slug: "developpement-international", label: "Développement international" },
    },
    {
        slug: "salons-internationaux",
        num: "04",
        title: "Salons internationaux",
        tagline: "Rentabiliser chaque participation.",
        seoTitle: "Accompagnement salons internationaux & export | WEYB",
        seoDescription:
            "WEYB prépare et accompagne votre participation aux salons internationaux : ciblage, prospection, rendez-vous B2B, préparation commerciale et suivi.",
        h1Title: "Salons internationaux",
        heroTagline: "transformer votre présence en opportunités commerciales",
        heroIntro:
            "Participer à un salon international ne suffit pas. WEYB accompagne les PME et équipes export avant, pendant et après les salons professionnels : ciblage des prospects, prospection, rendez-vous B2B, préparation commerciale et suivi des opportunités.",
        related: [
            { href: "/expertises/prospection-b2b-closing", label: "Avant le salon : la prospection B2B internationale" },
        ],
        image: "/assets/terrain-startup-village.jpg",
        imageAspect: "aspect-[4/3]",
        imageAlt: "Mission WEYB — écosystème startup et innovation",
        intro: "Un salon international se prépare des mois à l'avance. WEYB transforme vos participations en opérations commerciales structurées, avec des objectifs de rendez-vous et un suivi rigoureux.",
        points: [
            { title: "Sélection des salons", desc: "Choix des événements réellement adaptés à vos marchés et à votre offre." },
            { title: "Préparation", desc: "Objectifs, argumentaire, supports et ciblage des visiteurs et exposants à rencontrer." },
            { title: "Prise de rendez-vous", desc: "Organisation d'un agenda de rencontres qualifiées avant même votre arrivée." },
            { title: "Accompagnement sur place", desc: "Présence et appui pendant le salon, puis exploitation systématique des contacts." },
        ],
        outcomes: ["Des participations cadrées et mesurables", "Un agenda de rendez-vous qualifiés", "Un suivi post-salon qui produit des résultats"],
        solution: { slug: "developpement-international", label: "Développement international" },
    },
    {
        slug: "missions-b2b",
        num: "05",
        title: "Missions B2B",
        tagline: "Le terrain comme accélérateur.",
        seoTitle: "Missions commerciales internationales & B2B | WEYB",
        seoDescription:
            "WEYB organise et accompagne vos missions commerciales internationales : ciblage de marchés, identification d'acheteurs et rendez-vous B2B qualifiés.",
        h1Title: "Missions commerciales internationales",
        heroTagline: "rencontrer les bons partenaires",
        heroIntro:
            "WEYB conçoit et accompagne des missions commerciales internationales pour mettre les entreprises en relation avec des acheteurs, distributeurs et partenaires qualifiés sur leurs marchés cibles.",
        related: [
            { href: "/expertises/prospection-b2b-closing", label: "En amont : la prospection B2B internationale" },
        ],
        image: "/assets/terrain-enova.jpg",
        imageAspect: "aspect-[16/10]",
        imageAlt: "Mission B2B WEYB — visite d'entreprise industrielle",
        intro: "Rien ne remplace la rencontre. WEYB organise et accompagne vos missions commerciales sur les marchés cibles : rendez-vous qualifiés, visites d'entreprises, immersion locale.",
        points: [
            { title: "Organisation de missions", desc: "Programme, logistique et agenda de rendez-vous construits autour de vos objectifs." },
            { title: "Rendez-vous qualifiés", desc: "Des rencontres avec des partenaires identifiés et préparés en amont." },
            { title: "Accompagnement terrain", desc: "Un expert WEYB à vos côtés pendant la mission, y compris pour la négociation." },
            { title: "Suivi post-mission", desc: "Compte rendu, relances et intégration des opportunités dans votre pipeline export." },
        ],
        outcomes: ["Une immersion réelle sur votre marché cible", "Des relations nouées en face à face", "Des opportunités suivies après le retour"],
        solution: { slug: "developpement-international", label: "Développement international" },
    },
];
